import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store, initStore } from './store'
// 引入ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 引入通用的css
import './assets/css/common.css'
import './assets/css/login.css'
import './assets/css/dialog.css'
import './assets/css/override-element-ui.css'

//导入axios实例
import axiosAPI from "./components/request/request";
Vue.prototype.$axios = axiosAPI;

// app.config.globalProperties.$axios = axiosAPI  //配置axios的全局引用

// 富文本
import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'

// 注册样式属性模块
const fontSizeStyle = Quill.import('attributors/style/size')
const Font = Quill.import('attributors/style/font')
const Align = Quill.import('attributors/style/align')

// 配置白名单
fontSizeStyle.whitelist = ['12px', '14px', '16px']
Font.whitelist = ['SimSun', 'Microsoft-YaHei']
Align.whitelist = ['right', 'center']

// 激活样式模式
Quill.register(fontSizeStyle, true)
Quill.register(Font, true)
Quill.register(Align, true)



//md5
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
// cookies
import cookies from 'vue-cookies';
Vue.use(cookies);

import '@/assets/icons'
import SvgIcon from '@/components/SvgIcon.vue'

Vue.component('svg-icon', SvgIcon) // 全局注册
// @/代表src根目录
// 使用ElementUI
Vue.use(ElementUI);

// 自定义的错误提示框
import { confirmError } from './utils/confirmError';
Vue.prototype.$confirmError = confirmError;

// 流程设计组件
import nodeWrap from '@/components/nodeWrap'
Vue.component('nodeWrap', nodeWrap); //初始化组件
// 添加节点
import addNode from '@/components/addNode'
Vue.component('addNode', addNode); //初始化组件
// import './assets/css/override-element-ui.css'
import func from './components/plugins/preload.js'
Vue.prototype.$func = func;
// import './assets/css/draw.css'

import { checkPermission } from '@/directives/permission-directive'
Vue.prototype.$checkPermission = checkPermission

import directives from './directives';
// 全局注册指令
Vue.use(directives);

// 在Vue原型上添加指令帮助方法（可选）
Vue.prototype.$directives = {
    getConfig: () => {
        return {
            numberOnly: 'v-number-only 或 v-number-only="{decimal: 2, allowNegative: false}"',
        };
    }
};

import employeeApi from '@/api/employee.js';
// router.js
const whiteList = ['/approvalcenter/index'] // 白名单路由路径
// 路由守卫
router.beforeEach(async (to, from, next) => {
    const fullUrl = window.location.href;
    const url = new URL(fullUrl);
    const hash = window.location.hash;

    // 解析 hash 路径和参数
    const [hashPath, hashQueryString] = hash.split('?');
    const hashParams = new URLSearchParams(hashQueryString);
    let token = hashParams.get('token');
    if (token) {
        // 存储token并清理URL
        store.commit('user/SET_TOKEN', 'Bearer ' + token);
        // 获取用户信息
        try {
            const response = await employeeApi.getLoginUserInfo();
            const res = response.data;

            if (res.status === 200) {
                const result = res.data;
                const userInfo = {
                    userId: result.id,
                    userName: result.userName,
                    nickname: result.nickname,
                    roleName: result.roles?.lenght > 0 ? result.roles[0] : ''
                };
                store.commit('user/SET_USER', JSON.stringify(userInfo));
                console.log('用户信息获取成功', userInfo);
            } else {
                console.error(res.message);
            }
        } catch (error) {
            console.error('获取用户信息失败', error);
        }

        // 删除 token 参数并更新 URL
        hashParams.delete('token');
        const newHash = hashParams.toString()
            ? `${hashPath}?${hashParams.toString()}`
            : hashPath;
        const cleanUrl = `${url.origin}${url.pathname}${url.search}${newHash}`;
        window.history.replaceState({}, document.title, cleanUrl);
        console.log('跳转', newHash.replace(/^#/, ''))
        return next({
            path: newHash.replace(/^#/, ''),
            replace: true
        });
    }
    token = store.getters['user/getToken'];
    console.log(token)
    if (token && to.path === "/login") {
        next('/login/true');
    } else if (!token && to.path === "/login") {
        next();
    } else if (!token && to.path !== "/login") {
        // Vue.prototype.$confirmError('登陆错误，请重新登陆！')
        next('/login')
    } else {
        next();
    }
});



Vue.config.productionTip = false

new Vue({
    router,
    store,
    components: {
        nodeWrap,
        addNode,
    },
    created() {
        initStore()
    },
    render: h => h(App)
}).$mount('#app')
